import {
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";

import axios from "axios";

const API_BASE = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
).replace(/\/$/, "");

// ==========================
// /club/:slug PROFILE FETCH
// ==========================
export const fetchClubBySlug =
  createAsyncThunk(
    "client/fetchClubBySlug",
    async (
      slug: string,
      { rejectWithValue }
    ) => {
      try {
        const res =
          await axios.get(
            `${API_BASE}/client/public/${encodeURIComponent(
              slug
            )}`
          );

        return (
          res.data?.data ||
          null
        );
      } catch (error: any) {
        return rejectWithValue(
          error?.response?.data
            ?.message ||
            "Failed to fetch club profile"
        );
      }
    }
  );

const getSavedClient = () => {
  try {
    return JSON.parse(
      localStorage.getItem(
        "selectedClient"
      ) || "null"
    );
  } catch {
    return null;
  }
};

interface ClientState {
  selectedClient: any | null;
  clubProfile: any | null;
  loading: boolean;
  clubLoading: boolean;
  error: string | null;
}

const initialState: ClientState = {
  // for /:slug -> /home
  selectedClient:
    getSavedClient(),

  // for /club/:slug
  clubProfile: null,

  loading: false,
  clubLoading: false,
  error: null,
};

const clientSlice =
  createSlice({
    name: "client",

    initialState,

    reducers: {
      // ==========================
      // SET SLUG CLIENT
      // Used in ClientPublicPage
      // ==========================
      setSlugClient: (
        state,
        action
      ) => {
        state.selectedClient =
          action.payload;

        localStorage.setItem(
          "selectedClient",
          JSON.stringify(
            action.payload
          )
        );
      },

      // ==========================
      // CLEAR SLUG CLIENT
      // ==========================
      clearSlugClient: (
        state
      ) => {
        state.selectedClient =
          null;

        localStorage.removeItem(
          "selectedClient"
        );
      },

      // ==========================
      // CLEAR CLUB PROFILE
      // ==========================
      clearClubProfile: (
        state
      ) => {
        state.clubProfile =
          null;

        state.error = null;
      },
    },

    extraReducers: (
      builder
    ) => {
      builder
        .addCase(
          fetchClubBySlug.pending,
          (state) => {
            state.clubLoading =
              true;

            state.error = null;

            state.clubProfile =
              null;
          }
        )

        .addCase(
          fetchClubBySlug
            .fulfilled,
          (
            state,
            action
          ) => {
            state.clubLoading =
              false;

            state.clubProfile =
              action.payload;
          }
        )

        .addCase(
          fetchClubBySlug
            .rejected,
          (
            state,
            action
          ) => {
            state.clubLoading =
              false;

            state.error =
              (action.payload as string) ||
              "Failed to fetch club profile";
          }
        );
    },
  });

export const {
  setSlugClient,
  clearSlugClient,
  clearClubProfile,
} = clientSlice.actions;

export default clientSlice.reducer;
